<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update Bank" @show="showModal" @hide="$emit('cancelUpdate')">
    <div class="d-block">
      <b-row>
        <b-col sm="12" v-if="show">
          <b-row>
            <b-col sm="6">
              <p-input v-model="form.receiptAccountId" label="AccountId" name="receiptAccountId" :handler="$v" :formData="form" type="text" disabled/>
            </b-col>
            <b-col sm="6">
              <p-input v-model="form.receiptBankAccountName" label="Account Name" name="receiptBankAccountName" :handler="$v" :formData="form" type="text" disabled/>
            </b-col>
            <b-col sm="6">
              <p-input v-model="form.bankCode" label="Bank Code" name="bankCode" :handler="$v" :formData="form" type="text" disabled/>
            </b-col>
            <b-col sm="6">
              <p-input v-model="form.receiptBankAccount" label="Bank Account" name="receiptBankAccount" :handler="$v" :formData="form" type="text" disabled/>
            </b-col>
            <b-col sm="6">
              <p-select v-model="form.display" name="display" :options="statusOptions" :handler="$v" :formData="form" label="Status"/> 
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-button variant="success" @click="updateBank" :disabled="updateData.display === this.form.display">Update</b-button>
    <b-button variant="outline-danger" @click="$emit('cancelUpdate')">Cancel</b-button>
  </b-modal>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../../events.js'
import { PInput, PSelect } from '../../components'
const {required} = require('vuelidate/lib/validators')
export default {
  data: () => {
    return {
      statusOptions: [
        { Name: 'Please Select Device', Value: null },
        { Name: 'First Deposit', Value: 1 },
        { Name: 'Regular Deposit', Value: 0 }
      ],
      form: {
        receiptAccountId: '',
        receiptBankAccount: '',
        receiptBankAccountName: '',
        bankCode: '',
        display: '',
        errorMessages: {
          receiptAccountId: { },
          receiptBankAccount: { },
          receiptBankAccountName: { },
          bankCode: { },
          display: {
            required: 'Status is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      receiptAccountId: {},
      receiptBankAccount: {},
      receiptBankAccountName: {},
      bankCode: {},
      display: { required }
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showUpdateModal
      },
      set: function () {
        return this.showUpdateModal
      }
    }
  },
  props: {
    showUpdateModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    }
  },
  components: {
    PInput,
    PSelect
  },
  methods: {
    async showModal () {
      try {
        this.form.receiptAccountId = this.updateData.receiptAccountId
        this.form.receiptBankAccount = this.updateData.receiptBankAccount
        this.form.receiptBankAccountName = this.updateData.receiptBankAccountName
        this.form.bankCode = this.updateData.bankCode
        this.form.display = this.updateData.display
      } catch (err) {
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async updateBank () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        let data = {
          ReceiptAccountId: this.form.receiptAccountId
        }
        await this.$http.put(`${this.API_ENDPOINT}/payment/manual/deposit/updateBank`, data, { headers: { 'Content-Type': 'application/json' } })
        this.$emit('updateData')
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Bank Data Updated Successfully.')
      } catch (err) {
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/manualDeposit/UpdateManualDepositBank.vue